module.exports = __webpack_public_path__ + "static/media/Learning full.f01daf08.png";